/**
 * @augments {Component<{  imgLink:string.isRequired,
 *  clickHandler:Function,
 *  className:string,
 *   width:number,  height:number,>}
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ImageButton.scss';

const propTypes = {
  imgLink: PropTypes.string.isRequired,
  clickHandler: PropTypes.func,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
const defaultProps = {
  className: '',
  width: 10,
  height: 10,
  clickHandler: () => {},
};

const ImageButton = ({
  imgLink, clickHandler, className, width, height,
}) => {
  const imageButtonClasses = classNames({
    'image-button': true,
    [className]: true,
  });
  return (
    <button
      className={imageButtonClasses}
      style={{
        backgroundImage: `url(${imgLink}`,
        width: `${width}px`,
        height: `${height}px`,
      }}
      onClick={clickHandler}
    />
  );
};

ImageButton.propTypes = propTypes;
ImageButton.defaultProps = defaultProps;

export default ImageButton;



// WEBPACK FOOTER //
// ./src/components/_atomic/ImageButton/ImageButton.js